export default __webpack_public_path__ + "static/media/send-to-p3.8b37c516.svg";